import { Container } from '@mantine/core';
import { Button, SectionTitle } from '@sloyd/ui';
import { Row, Textarea, Wrapper } from './ContentAnalytics.style';

export type ContentAnalyticsProps = {};

export function ContentAnalytics(_props: ContentAnalyticsProps) {
  return (
    <Wrapper className='ContentAnalytics-wrapper' data-testid='ContentAnalytics-wrapper'>
      <Container>
        <SectionTitle gradient={{ from: '#ff6a00', to: '#ee0979' }} title='Analytics Playground'>
          Try our <strong>analytics-driven</strong> components
        </SectionTitle>
        <Row>
          <Button analytics>Simple</Button>
          <Button analyticsId='Event name'>With event name</Button>
          <Button analyticsParams={{ b: 10 }}>With params</Button>
          <Button analyticsSelectorId='$example2'>With selector</Button>
        </Row>
        <Textarea className='analytics-log' />
      </Container>
    </Wrapper>
  );
}

export default ContentAnalytics;
